import { React } from 'react';
import { Button, Grid, Typography } from '@material-ui/core';

import './SendAppLinkModal.css';

function trackSendApp() {
  const phoneNumber = document.getElementById('phone').value;
  window.analytics.track('Send App SMS Triggered', {
    input_value: phoneNumber,
  });
}

function SendAppLinkModal() {
  return (
    <form action='https://kumu-alternate.app.link/PNQg4Z7Qu0?__branch_flow_type=deepview_tmta&amp;__branch_flow_id=768771099283776860&amp;__branch_desktop_deepview_type=1' method='POST'>
      <Grid container className='mobile-number-container'>
        <Grid item>
          <Typography className='mobileLabel'>Mobile Number:</Typography>
        </Grid>
        <Grid item>
          <input name='phone' type='number' id='phone' className='numberInput' required placeholder='ex. 639177480908' autoComplete='off' />
        </Grid>
      </Grid>
      <Button className='sendText' type='submit' onClick={() => trackSendApp()}>Send</Button>
    </form>
  );
}

export default SendAppLinkModal;
